// El estado de pago y el medio de pago tienen exactamente el mismo
// significado y los mismos valores permitidos que en gastos, así que se
// reutilizan `obtenerEstadoPago` y `formatearMedioPago` desde
// `src/utils/gastos.js` en vez de duplicarlos aquí.

export const TIPOS_DOCUMENTO_INGRESO = {
  factura: 'Factura',
  factura_exenta: 'Factura exenta',
  boleta: 'Boleta',
  nota_credito: 'Nota de crédito',
  recibo: 'Recibo',
  sin_documento: 'Sin documento',
  otro: 'Otro',
}

export function formatearTipoDocumentoIngreso(valor) {
  return (
    TIPOS_DOCUMENTO_INGRESO[valor] || valor || 'Sin especificar'
  )
}

export function formatearMontoIngreso(monto) {
  return (Number(monto) || 0).toLocaleString('es-CL', {
    style: 'currency',
    currency: 'CLP',
    maximumFractionDigits: 0,
  })
}

export function formatearFechaIngreso(fechaTexto) {
  if (!fechaTexto) return '—'

  const [anio, mes, dia] = fechaTexto.split('-')

  if (!anio || !mes || !dia) return '—'

  return `${dia}-${mes}-${anio}`
}
